/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  AdminObjectState,
  SignalAdminResourceApiBase,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface EmailTemplateTeam {
  id: string;
  name?: string;
}

export interface EmailTemplateModel {
  id: string;
  name?: string;
  description?: string;
  type?: string;
  team?: EmailTemplateTeam | null;
  h1?: string;
  h2?: string;
  pLarge?: string;
  pMedium?: string;
  pSmall?: string;
  pSmaller?: string;
  a?: string;
  template?: string;
  specifyEmailTemplate?: boolean;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

@Injectable({providedIn: 'root'})
export class EmailTemplateApiService extends SignalAdminResourceApiBase<EmailTemplateModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'emailtemplates', {showEditableOnly: true});
  }

  listTeams(params: Record<string, any>): Observable<SignalAdminResourcePage<EmailTemplateTeam>> {
    return this.client.request<SignalAdminResourcePage<EmailTemplateTeam>>({
      method: 'GET',
      url: this.resourceUri('teams'),
      // Same defaults the old Team.query() resource applied.
      params: {includeActive: true, includeInactive: false, includeHidden: false, orderBy: 'name', pageSize: 1001, ...params}
    });
  }
}
